// extracted by mini-css-extract-plugin
export var content = "SimpleHero-module--content--dc9f3";
export var equals = "SimpleHero-module--equals--9ff41";
export var large = "SimpleHero-module--large--ffebc";
export var simplehero = "SimpleHero-module--simplehero--9aafd";